import React, { useEffect } from 'react'
import { ISelectOption, TRequestOptionsCallback } from './ISelect'
import { RecoilState, useRecoilState } from 'recoil'

export interface IGlobalStateProps<T = ISelectOption> {
  items: T[] | null
}

type TStateType<T> = T[] | null

function withGlobalState<
  ComponentPropsType extends object,
  ItemsType extends ISelectOption = ISelectOption
>(
  recoilState: RecoilState<TStateType<ItemsType>>,
  request: (callback: TRequestOptionsCallback) => void,
  WrappedComponent: React.ComponentType<ComponentPropsType & IGlobalStateProps<ItemsType>>
) {
  return ({ ...props }: ComponentPropsType) => {
    const [items, setItems] = useRecoilState<TStateType<ItemsType>>(recoilState)

    useEffect(() => {
      if (!items) {
        request((newItems) => {
          setItems(newItems as ItemsType[])
        })
      }
    }, [items, setItems])

    return <WrappedComponent items={items} {...(props as ComponentPropsType)} />
  }
}

export default withGlobalState
